// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  ======================
    Component styles on page load
    ====================== */

.Alert_alert__lqeye {
    padding: 16px 20px;
    border: none;
    border-radius: 4px;
}

/* alert colors by type */
.Alert_info__Yw\\+m5, .Alert_success__H2Ttd, .Alert_warning__C9IE3   { color: var(--color-darkui-surface-1); }
.Alert_error__3MDf9                      { color: var(--color-text-light); }

.Alert_info__Yw\\+m5     { background-color: var(--color-lightui-surface-4); }
.Alert_success__H2Ttd  { background-color: var(--color-green-light-1); }
.Alert_warning__C9IE3  { background-color: var(--color-yellow-dark-1); }
.Alert_error__3MDf9    { background-color: var(--color-red-dark-2); }


/* alert close button */
.Alert_closeBtn__Bn\\+xr {
    position: relative;
    float: right;
    top: -2px;
    right: -2px;
    height: 22px;
    width: 22px;
    margin: 0 0 8px 16px;
    opacity: 1;
    -webkit-appearance: none;
    border: 0;
    font-size: 22px;
    font-weight: 100;
    line-height: 22px;
    text-shadow: none;
    color: black;
}
.Alert_closeBtn__Bn\\+xr:focus {
    font-weight: bold;
    outline: none;
}
.Alert_alert__lqeye.Alert_error__3MDf9 .Alert_closeBtn__Bn\\+xr {
    color: white;
}


/* alert titles */
.Alert_alert__lqeye h4 {
    margin-bottom: 4px;
    font-size: 17px;
    font-weight: 600;
    color: var(--color-darkui-surface-1);
}
.Alert_alert__lqeye.Alert_error__3MDf9 h4 {
    color: var(--color-text-light);
}


/* alert links */
.Alert_alert__lqeye a,
.Alert_alert__lqeye a:visited,
.Alert_alert__lqeye a:focus,
.Alert_alert__lqeye a:hover,
.Alert_alert__lqeye a:active {
    text-decoration: underline;
    color: var(--color-darkui-surface-1);
}

.Alert_alert__lqeye.Alert_error__3MDf9 a,
.Alert_alert__lqeye.Alert_error__3MDf9 a:visited,
.Alert_alert__lqeye.Alert_error__3MDf9 a:focus,
.Alert_alert__lqeye.Alert_error__3MDf9 a:hover,
.Alert_alert__lqeye.Alert_error__3MDf9 a:active {
    color: var(--color-text-light);
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Alert/Alert.module.css"],"names":[],"mappings":"AAAA;;4BAE4B;;AAE5B;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA,yBAAyB;AACzB,sEAA8B,oCAAoC,EAAE;AACpE,2CAA8B,8BAA8B,EAAE;;AAE9D,0BAAY,gDAAgD,EAAE;AAC9D,yBAAY,4CAA4C,EAAE;AAC1D,yBAAY,4CAA4C,EAAE;AAC1D,yBAAY,yCAAyC,EAAE;;;AAGvD,uBAAuB;AACvB;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,WAAW;IACX,YAAY;IACZ,WAAW;IACX,oBAAoB;IACpB,UAAU;IACV,wBAAwB;IACxB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,aAAa;AACjB;AACA;IACI,YAAY;AAChB;;;AAGA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,oCAAoC;AACxC;AACA;IACI,8BAA8B;AAClC;;;AAGA,gBAAgB;AAChB;;;;;IAKI,0BAA0B;IAC1B,oCAAoC;AACxC;;AAEA;;;;;IAKI,8BAA8B;AAClC","sourcesContent":["/*  ======================\n    Component styles on page load\n    ====================== */\n\n.alert {\n    padding: 16px 20px;\n    border: none;\n    border-radius: 4px;\n}\n\n/* alert colors by type */\n.info, .success, .warning   { color: var(--color-darkui-surface-1); }\n.error                      { color: var(--color-text-light); }\n\n.info     { background-color: var(--color-lightui-surface-4); }\n.success  { background-color: var(--color-green-light-1); }\n.warning  { background-color: var(--color-yellow-dark-1); }\n.error    { background-color: var(--color-red-dark-2); }\n\n\n/* alert close button */\n.closeBtn {\n    position: relative;\n    float: right;\n    top: -2px;\n    right: -2px;\n    height: 22px;\n    width: 22px;\n    margin: 0 0 8px 16px;\n    opacity: 1;\n    -webkit-appearance: none;\n    border: 0;\n    font-size: 22px;\n    font-weight: 100;\n    line-height: 22px;\n    text-shadow: none;\n    color: black;\n}\n.closeBtn:focus {\n    font-weight: bold;\n    outline: none;\n}\n.alert.error .closeBtn {\n    color: white;\n}\n\n\n/* alert titles */\n.alert h4 {\n    margin-bottom: 4px;\n    font-size: 17px;\n    font-weight: 600;\n    color: var(--color-darkui-surface-1);\n}\n.alert.error h4 {\n    color: var(--color-text-light);\n}\n\n\n/* alert links */\n.alert a,\n.alert a:visited,\n.alert a:focus,\n.alert a:hover,\n.alert a:active {\n    text-decoration: underline;\n    color: var(--color-darkui-surface-1);\n}\n\n.alert.error a,\n.alert.error a:visited,\n.alert.error a:focus,\n.alert.error a:hover,\n.alert.error a:active {\n    color: var(--color-text-light);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alert": `Alert_alert__lqeye`,
	"info": `Alert_info__Yw+m5`,
	"success": `Alert_success__H2Ttd`,
	"warning": `Alert_warning__C9IE3`,
	"error": `Alert_error__3MDf9`,
	"closeBtn": `Alert_closeBtn__Bn+xr`
};
export default ___CSS_LOADER_EXPORT___;
